import _ from 'lodash';
import { IntegrationStatusEnum } from 'src/types/settings/profile';
import moment from 'moment';
import dateformat from 'dateformat';
import orderedCapabilitiesTypes from './orderedCapabilitiesTypes.json'

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export const isUrlValid = (uri="") => {
  const re_weburl = new RegExp(
    "^" +
    // protocol identifier
    "(?:(?:https?|ftp)://)" +
    // user:pass authentication
    "(?:\\S+(?::\\S*)?@)?" +
    "(?:" +
    // IP address exclusion
    // private & local networks
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
    "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
    "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
    // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broacast addresses
    // (first & last IP address of each class)
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
    "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
    "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
    "|" +
    // host name
    "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
    // domain name
    "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
    // TLD identifier
    "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
    // TLD may end with dot
    "\\.?" +
    ")" +
    // port number
    "(?::\\d{2,5})?" +
    // resource path
    "(?:[/?#]\\S*)?" +
    "$", "i"
  );
  return re_weburl.test(uri);
}
export const fixHTTPUrl=(url)=> {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    url = "https://" + url;
  }
  return url;
}

export const secondsToMinutes = (seconds) => {
  const safeSeconds = _.toNumber(seconds); // handles null, undefined, strings
  if (_.isNaN(safeSeconds) || safeSeconds < 0) return 0;
  return _.floor(safeSeconds / 60); // returns whole minutes
}
export const calculatePercentage = (active, total) => {
  if (total === 0) return 0;
  return Math.round((active / total) * 100);
};

/*
 * filterTimeLineEvents (Method)
 *
 * @param {moment.Moment} fromDate - moment Date.
 * @param {moment.Moment} toDate - moment Date.
 * @param {Array<Object>} events.
 *
 * @returns {Array<Object>} filteredEvents - Returns a list of grouped events by date.
 */
export const filterTimeLineEvents = (fromDate, toDate, events) => {
  let filteredEvents = [];
  const filteredByDate = _.omit(
    _.groupBy(events, (item) => {
      if (fromDate && toDate) {
        let getTheDate = moment(item.createdDate);
        console.log(
          getTheDate.isBetween(fromDate, toDate, "day", "[]"),
          "IsBetween",
          item,
        );
        return getTheDate.isBetween(fromDate, toDate, "day", "[]")
          ? dateformat(item.createdDate, "mmm dd, yyyy")
          : "undefined"; // jun 34 2025
      }

      return dateformat(item.createdDate, "mmm dd, yyyy");
    }),
    "undefined",
  );

  /* FilteredByDate will provide a object, {
       key(Date as key i.e, jul 25 2025): [{events}, {events}],
     } 
  */

  if (_.size(filteredByDate) > 0) {
    filteredEvents = _.map(filteredByDate, (item, date) => {
      const contacts = _.map(
        _.omit(_.groupBy(item, "visitor.id"), "undefined"),
        (contact, index) => ({
          recipient: index,
          event: contact,
        }),
      );
      const visitors = _.map(
        _.omit(_.groupBy(item, "contact.id"), "undefined"),
        (visitor, index) => ({
          recipient: index,
          event: visitor,
        }),
      );

      return {
        date, // 'MMM DD YYY'
        events: _.concat(visitors, contacts),
      };
    });
  }

  /* FilteredEvents = [{
     date: 'MMM DD, YYYY', // e.g., 'Jul 25, 2025'
     events: [
       { recipient: <visitor/contact id>, event: [<event objects>] },
       ...
     ]
   }] */

  return filteredEvents;
};


export const getIntegrationPath = (key) => {
  if (key == null) return null;

  switch (key) {
    case "paperflite.integration.salesforce.sandbox":
      return "salesforce-sandbox";
    case "paperflite.integration.salesforce.v2":
      return "salesforce";
    case "hubspot_integration":
      return "hubspot";
    case "paperflite.integration.ms_dynamics.v2":
      return "ms-dynamics";
    case "paperflite.integration.netsuite":
      return "netsuite";
    case "paperflite.integration.zoho.v2":
      return "zoho";
    case "freshsales_integration":
      return "freshsales";
    case "cleverstory_integration":
      return "cleverstory";
    case "slack_integration":
      return "slack";
    case "gmail_integration":
      return "gmail";
    case "zoom_integration":
      return "zoom";
    case "outlook_integration":
      return "outlook";
    case "smtp_integration":
      return "smtp";
    case "klenty_integration":
      return "klenty";
    case "outreach_integration":
      return "outreach";
    case "linkedin_integration":
      return "linkedin";
    case "pipedrive_integration":
      return "pipedrive";
    case "salesloft_integration":
      return "salesloft";
    case "ios_application":
      return "ios-application";
    case "windows_application":
      return "windows-application";
    case "macos_application":
      return "macos-application";
    case "chrome_extension":
      return "chrome-extension";
    case "salesforce_native":
      return "salesforce-native";
    case "ms_dynamics_native":
      return "ms-dynamics-native";
    case "outlook_addin":
      return "outlook-addin";
    case "driftchat_integration":
      return "driftchat";
    case "freshchat_integration":
      return "freshchat";
    case "freshmarketer_integration":
      return "freshmarketer";
    case "intercom_integration":
      return "intercom";
    case "marketo_integration":
      return "marketo";
    case "eloqua_integration":
      return "eloqua";
    case "pardot_integration":
      return "pardot";
    case "fullstory_integration":
      return "fullstory";
    case "google_analytics_integration":
      return "google-analytics";
    case "google_analytics_4_integration":
      return "google-analytics-4";
    case "google_tag_manager_integration":
      return "google-tag-manager";
    case "six_sense_integration":
      return "six-sense";
    case "external_script_integration":
      return "external-script";
    default:
      return key; // fallback
  }

}

/**
 * copyToClipboard - Copies the provided text to the clipboard
 * @param {string} [text=''] - The text to copy to clipboard, defaults to empty string if null/undefined
 * @returns {Promise<boolean>} True if copying was successful, false otherwise
*/

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text ?? '');
    return true; 
  } catch (err) {
    return false;
   }
}

/**
 * orderCapabilities - Orders capabilities array based on predefined type order.
 * 
 * @param {Array} capabilities - Array of capability objects to sort
 * @returns {Array} Sorted array of capabilities based on their type position in orderedCapabilitiesTypes
 *
 */
export const orderCapabilities = (capabilities) => {
  if (capabilities && _.size(capabilities) === 0) return [];

  return _.compact(
    _.map(orderedCapabilitiesTypes, (type) =>
      _.find(capabilities, ['productCapabilityResponse.type', type])
    )
  );
};

/** 
 * setChromeExtAlertBannerVisible(val):
 * Saves the Chrome extension alert banner visibility preference in localStorage.
*/
export const setChromeExtAlertBannerVisible = (val) => {
    localStorage.setItem("showChromeExtAlert", val ? "true" : "false");
}